import { createSelector } from 'reselect'
import activityDataSelector from 'redux/selectors/interactive_videos/activity_data_selector'
import activityTypes from 'helpers/enums/activityTypes'

const getActivityData = (state, activityUid) => activityDataSelector(state, activityUid)

const getOeqFormattedData = activityData => [activityData.text]

const getMCQFormattedData = activityData => {
	const response = []
	response.push(activityData.text)
	activityData.answers.forEach((answer, index) => {
		const label = String.fromCharCode(65 + index)
		response.push(`${label}. ${answer.media.payload.text}`)
	})
	return response
}

export default createSelector(
	[ getActivityData ],
	activityData => {
		switch (activityData.type) {
			case activityTypes.OPEN_ENDED_QUESTION:
				return getOeqFormattedData(activityData.payload)
			case activityTypes.MULTIPLE_CHOICE_QUESTION:
				return getMCQFormattedData(activityData.payload)
			default:
				return []
		}
	}
)
